import React from "react";
import ListComponent from "Components/ListComponent";
import { Tooltip, Typography, message, Input } from "antd";
import api from '../../utils/api';
import utils from "utils";
import icons from "Common/Icons";
import "./Others.scss";
import { CONSTANTS } from "utils/constant";
import configureStore from "store/index";
const { store } = configureStore();
const { TextArea } = Input;
export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      casesheetData: [],
      notes: "",
      enableEditing: false,
      notes_length: 0
    };
    this.casesheet = React.createRef();
  }
  componentDidMount() {
    this.getCasesheet(this.props.data?.patient_id);
  }

  updateCaseSheet(appointment_id) {
    if(this.state.notes_length == 0) {message.error(`${CONSTANTS.CASESHEET_UPDATE_ERROR_MESSAGE}`, ErrorDuration); return}

    this.setState({
      enableEditing: false,
      showSave: false,
      casesheetData: undefined
    });
    
    let casenotes = this.state.notes?.[`${appointment_id}`]
    if (casenotes && this.state.notes_length > 0) {
      api
        .casesheet_submit({ appointment_id, casenotes: casenotes, missed_casenotes: false ,is_casenotes_required : true})
        .then((res) => {
          if (res.data?.status == 200) {
            message.success(res.data?.message, ErrorDuration);
            this.getCasesheet(this.props.data?.patient_id);
          }
        });
    }    
    return 0

  }

  getCasesheet(id) {
    this.setState({
      casesheetData: undefined,
      notes_length: 0
    });
    if(this.props?.recorddata){
      let data = this.props?.recorddata;
      let final_data = data;
      final_data.forEach(m => {
        this.setState({
          notes: {
            [m.appointment_id]: m.notes
          }
        })
      })
      this.setState({ casesheetData: final_data });
    }
    else{
      api
      .casesheet_list(id)
      .then((response) => {
        let data = response.data?.data.results;
        let final_data = data;
        final_data.forEach(m => {
          this.setState({
            notes: {
              [m.appointment_id]: m.notes
            }
          })
        })
        this.setState({ casesheetData: final_data });
      })
      .catch(() => {
        this.setState({
          casesheetData: null
        });
      });}
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.state.casesheetData !== nextState.casesheetData) return true;
    else if (this.state.showSave !== nextState.showSave) return true;
    else if (this.state.enableEditing !== nextState.enableEditing) return true;
    else return false;
  }

  render() {
    return (
      <div className="casesheet-popup">
        <div className="main-div">
        {(this.props.from !== "consultation")&&<div className="casesheet-header">
            <div>{CONSTANTS.CASENOTES}</div>
          </div>}

          <ListComponent
            className="casenotes-list"
            renderType="server"
            data={this.state.casesheetData}
            pagination={null}
            render={(listItem) => {
              return (
                <div 
                // className="casesheet-card" 
                key={listItem.appointment_id}>
                 {!this.props?.recorddata &&<div className="title-txt" style={{border:"none"}}>
                    <div className="date-day-txt">
                      {utils.FormatDate(listItem.consultation_date, "DATE_14")}, {utils.FormatDate(listItem.consultation_date, "TIME_1")}&nbsp;
                      {((store.getState()?.loginReducer?.user_details?.name == listItem.consultation_doctor) &&( this.props?.recorddata?false:listItem.is_editable)) ?
                      <>
                      {this.state.selectedAppointmentId == listItem.appointment_id && this.state.showSave && <Tooltip placement="top" title={CONSTANTS.SAVE}>
                        <img src={icons.save_icon} style={{ cursor: "pointer" }} onClick={e => {
                          this.updateCaseSheet(listItem.appointment_id)
                        }} />
                      </Tooltip> || <Tooltip placement="top" title={CONSTANTS.EDIT}>
                          <img src={icons.edit_icon} style={{ cursor: "pointer" }}
                            onClick={e => {
                              this.setState({
                                selectedAppointmentId: listItem.appointment_id,
                                enableEditing: true,
                                showSave: true
                              })
                            }} />
                        </Tooltip>}
                      </> : ""}

                    </div>
                    <div className="doctor-name-casesheet">{utils.FirstNameLastName(utils.salutationPrefixName(listItem.doctor_salutation, utils.getDisplayName(listItem.consultation_doctor, listItem.doctor_last_name)), "250px")}</div>

                  </div>}
                  {
                    this.state.selectedAppointmentId == listItem.appointment_id && this.state.enableEditing ?

                      <TextArea
                        id={listItem.appointment_id}
                        defaultValue={listItem.notes}
                        rows={4}

                        onChange={e => {
                          e.target.value.length > 0 ?

                            this.setState({
                              notes: {
                                [listItem.appointment_id]: e.target.value
                              }, notes_length: e.target.value == listItem.notes ? 0 : e.target.value?.trim()?.length
                            }) : this.setState({
                              notes: {
                                [listItem.appointment_id]: `${CONSTANTS.PLEASE_ENTER_NOTES}`
                              }, notes_length: 0
                            })
                        }}
                      /> : <div className="notes">{utils.LineSplit(listItem.notes)}
                      </div>
                  }
                </div>
              );
            }}
          />
        </div>
      </div>
    );
  }
}
